import React from 'react'
import { GalleryStyles as styles } from "./chat.tailwind";
import invalid_file from "../../../../../../assets/images/invalif_file.png"
const UnknownPreview = () => {
    return (
        <div
            className={`${styles.previewFile} h-full w-full flex justify-center items-start py-3 bg-black bg-opacity-50 backdrop-blur-sm`}
        >
            <img src={invalid_file} alt="invalid File" />
        </div>
    )
}

export default UnknownPreview